import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import en from "./translations/en.json";
import de from "./translations/de.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: { translation: en },
  de: { translation: de },
};

const languageDetectorOptions = {
  // order and from where user language should be detected
  order: [
    "querystring",
    "localStorage",
    "sessionStorage",
    "browser",
    "navigator",
    "htmlTag",
    "path",
    "subdomain",
  ],
};

i18n
  // .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "en",
    load: "languageOnly",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
    detection: languageDetectorOptions,
  });

export default i18n;
